import createIcon from '../../createIcon';

/**
 * @component @name SevereCold
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuNSAxMC40MUwxNi41IDYuNDFMMTUuMDkgNUwxMi41IDcuNTlWNEgxMC41VjcuNTlMNy45MSA1TDYuNSA2LjQxTDEwLjUgMTAuNDFWMTJIOC45MUw0LjkxIDhMMy41IDkuNDFMNi4wOSAxMkgyLjVWMTRINi4wOUwzLjUgMTYuNTlMNC45MSAxOEw4LjkxIDE0SDEwLjVWMTUuNTlMNi41IDE5LjU5TDcuOTEgMjFMMTAuNSAxOC40MVYyMkgxMi41VjE4LjQxTDE1LjA5IDIxTDE2LjUgMTkuNTlMMTIuNSAxNS41OVYxNEgxNC4wOUwxOC4wOSAxOEwxOS41IDE2LjU5TDE2LjkxIDE0SDIwLjVWMTJIMTIuNVYxMC40MVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMS41IDJIMTkuNVY3SDIxLjVWMloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMS41IDhIMTkuNVYxMEgyMS41VjhaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SevereCold = createIcon('SevereCold', [
  [
    'path',
    {
      d: 'M12.5 10.41L16.5 6.41L15.09 5L12.5 7.59V4H10.5V7.59L7.91 5L6.5 6.41L10.5 10.41V12H8.91L4.91 8L3.5 9.41L6.09 12H2.5V14H6.09L3.5 16.59L4.91 18L8.91 14H10.5V15.59L6.5 19.59L7.91 21L10.5 18.41V22H12.5V18.41L15.09 21L16.5 19.59L12.5 15.59V14H14.09L18.09 18L19.5 16.59L16.91 14H20.5V12H12.5V10.41Z',
      key: '14w22v',
    },
  ],
  ['path', { d: 'M21.5 2H19.5V7H21.5V2Z', key: 'fip85z' }],
  ['path', { d: 'M21.5 8H19.5V10H21.5V8Z', key: '1ay57l' }],
]);

export default SevereCold;
